import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "src/api/apiService";
import ClaimDialog from "../../components/Form/Claim/ClaimDialog";
import HomeUserClaimDialog from "../../components/Form/Claim/HomeUserClaimDialog";
import { usePermissions } from "src/hooks/usePermissions";
import { onFetchNextPageProps } from "src/context/Feed/types";
import { FeedProvider } from "src/context/Feed";
import { Dashboard } from "src/templates";
import ActionSectionResponsive from "./ActionSection";
import ContentSectionResponsive from "./ContentSection";
import {
  mapRequestsToRows,
  PremiseRequest,
  SortByEnum,
} from "src/components/Changes";
import { PageTitleSection } from "./PageTitleSection";

export const Changes: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [claimDialogOpen, setClaimDialogOpen] = useState<boolean>(false);
  const { isHomeUser } = usePermissions();

  const handleFetchNextPage = async ({
    searchTerm,
    page,
    sortConfig,
  }: onFetchNextPageProps) => {
    const premisesUrl = projectId ? `/request/${projectId}` : "/request";
    const response = projectId
      ? await apiClient.get<{ requests: PremiseRequest[] }>(premisesUrl, {
          params: {
            page,
            limit: 10,
            sortDirection: sortConfig.direction,
            sortBy: sortConfig.key,
            searchTerm: searchTerm?.trim() || undefined,
            connection: "EXISTING",
          },
        })
      : await apiClient.post<{ requests: PremiseRequest[] }>(premisesUrl, {
          page,
          limit: 10,
          sortDirection: sortConfig.direction,
          sortBy: sortConfig.key,
          searchTerm: searchTerm?.trim() || undefined,
          connection: "EXISTING",
        });
    return {
      newData: mapRequestsToRows(response.data.requests),
      isEOL: response.data.requests.length === 0,
    };
  };

  return (
    <FeedProvider
      onFetchNextPage={handleFetchNextPage}
      initialState={{
        sortConfig: { key: SortByEnum.UPDATED, direction: "DESC" },
      }}
    >
      <Dashboard
        pageTitleSection={<PageTitleSection />}
        actionSection={<ActionSectionResponsive />}
        data-id="changesDashboard"
      >
        <ContentSectionResponsive />
        {/* End Actions container */}
        {isHomeUser ? (
          <HomeUserClaimDialog
            open={claimDialogOpen}
            setOpen={setClaimDialogOpen}
          />
        ) : (
          <ClaimDialog open={claimDialogOpen} setOpen={setClaimDialogOpen} />
        )}
      </Dashboard>
    </FeedProvider>
  );
};
